import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  content: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      sx={{
        "& .MuiDialog-paper": {
          margin: { xs: 2, sm: 4 },
          width: "100%",
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: "8px 16px",
          fontSize: { xs: "1rem", sm: "1.25rem" },
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "8px 16px",
        }}
      >
        <DialogContentText
          sx={{
            fontSize: { xs: "0.9rem", sm: "1rem" },
            width: "100%",
            margin: 0,
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "8px 16px",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={onCancel}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="secondary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : t("common.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
